export const APP_NAME = 'Otakotakdev';

export const GOAL_STATUSES = ['inbox', 'active', 'completed', 'cancelled', 'archived'] as const;
export type GoalStatus = (typeof GOAL_STATUSES)[number];

export const GOAL_PRIORITIES = ['low', 'medium', 'high'] as const;
export type GoalPriority = (typeof GOAL_PRIORITIES)[number];

export const ACTIVITY_STATUSES = ['planned', 'in_progress', 'completed', 'cancelled'] as const;
export type ActivityStatus = (typeof ACTIVITY_STATUSES)[number];

export const SOURCES = ['discord', 'dashboard', 'scheduler'] as const;
export type Source = (typeof SOURCES)[number];

export const NOTE_TYPES = ['quick_note', 'idea', 'journal', 'reference', 'decision'] as const;
export type NoteType = (typeof NOTE_TYPES)[number];

export const CHECK_IN_TYPES = ['morning', 'clockout', 'end_of_day', 'custom'] as const;
export type CheckInType = (typeof CHECK_IN_TYPES)[number];

export const MOODS = ['good', 'neutral', 'difficult'] as const;
export type Mood = (typeof MOODS)[number];

export const REMINDER_TYPES = [
  'morning_brief',
  'clockout',
  'end_of_day',
  'weekly_review',
  'greeting',
] as const;
export type ReminderType = (typeof REMINDER_TYPES)[number];

export const REMINDER_STATUSES = ['pending', 'sent', 'failed', 'skipped'] as const;
export type ReminderStatus = (typeof REMINDER_STATUSES)[number];

export const DEFAULT_TIMEZONE = 'Asia/Jakarta';

/** Field length limits shared between Discord, API and dashboard validation. */
export const LIMITS = {
  goalTitle: { min: 1, max: 200 },
  goalDescription: { max: 4000 },
  activityTitle: { min: 1, max: 200 },
  activityDescription: { max: 4000 },
  noteContent: { min: 1, max: 20000 },
  tagName: { min: 1, max: 50 },
  displayName: { min: 1, max: 100 },
  searchQuery: { min: 1, max: 100 },
  settingValue: { max: 500 },
  summary: { max: 2000 },
  errorMessage: { max: 2000 },
  activityDurationMinutes: { min: 0, max: 24 * 60 },
  energy: { min: 1, max: 5 },
} as const;

export const PAGINATION = {
  defaultLimit: 25,
  maxLimit: 100,
} as const;

export const API_BASE_PATH = '/api/v1';

export const DISCORD_INTERACTIONS_PATH = '/discord/interactions';

/** In-memory rate limits (per isolate). */
export const RATE_LIMITS = {
  login: { windowMs: 60_000, maxAttempts: 5 },
  discordInteractions: { windowMs: 60_000, maxAttempts: 120 },
  changePassword: { windowMs: 15 * 60_000, maxAttempts: 5 },
} as const;

/** Password policy for the dashboard password (deliberately passphrase-friendly). */
export const PASSWORD_POLICY = {
  minLength: 10,
  maxLength: 128,
} as const;

export const SESSION = {
  cookieName: 'sb_session',
  ttlSeconds: 7 * 24 * 60 * 60,
} as const;
